export const getSelectedVehicleId = (state) => state.history_and_state.selectedId;
export const getVehicleStateVisible = (state) => state.history_and_state.vehicleStateVisible;

//TODO move to central entitiy selectors
export const getVehicles = (state) => state.entities.vehicle;
export const getVehicleById = (state, listVehicleId) => getVehicles(state)[listVehicleId];